import { render, staticRenderFns } from "./PriceChangeHistoryReport.vue?vue&type=template&id=3b476faf&"
import script from "./PriceChangeHistoryReport.vue?vue&type=script&lang=js&"
export * from "./PriceChangeHistoryReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports